<template>
<div>
    <CapBlog/>
    <div class="container">
        <div v-if="post">
            <div class="card mt-3">
                <div class="car-header">
                    <img :src="'/images/' + post.image" class="card-img-top" alt="">
                </div>
                <div class="card-body">
                    <h5 class="card-title">{{ post.title }}</h5>
                    <p class="card-text">{{ post.content }}</p>
                </div>
            </div>
        </div>
        <div v-else><h1>El Post no existeix!!</h1></div>
    </div>
</div>
</template>

<script>
    export default {
        
        created(){
            console.log ("Creat....."+ this.$route.params.id);
            this.getPost();
        },

        methods:{
            getPost: function() {
                fetch('/api/post/' + this.$route.params.id)
                    .then( response => response.json())
                    .then( json => this.post = json.data);
                    console.log ("GetPost....."+ this.$route.params.id);
            }
        },
    
        data: function() {
            return {
                postSelected: "",
                post: ""   
                }
        }

        
    }
</script>